import {
  CHOOSE,
  CODE,
  DROP,
  PACKAGE,
  VALIDATE,
  VOUCHER,
} from "../core/constants";

import BodyTextMedium from "./BodyTextMedium";
import Box from "./Box";
import ChooseIcon from "../assets/Icn-02-ChooseItem.svg";
import DropParcelIcon from "../assets/Icn-04-DropParcel.svg";
import GreenArrow from "../assets/green-arrow.svg";
import InsertCodeIcon from "../assets/Icn-07-InsertCode.svg";
import PackageIcon from "../assets/Icn-03-Package.svg";
import React from "react";
import ValidateIcon from "../assets/Icn-05-Validate.svg";
import VoucherIcon from "../assets/Icn-06-Voucher.svg";

function getIcon(iconName) {
  let icon;
  switch (iconName) {
    case CHOOSE:
      icon = ChooseIcon;
      break;
    case PACKAGE:
      icon = PackageIcon;
      break;
    case DROP:
      icon = DropParcelIcon;
      break;
    case VALIDATE:
      icon = ValidateIcon;
      break;
    case VOUCHER:
      icon = VoucherIcon;
      break;
    case CODE:
      icon = InsertCodeIcon;
      break;
    default:
      return;
  }
  return icon;
}

function TakebackStep({ text, icon, number, showArrow }) {
  const Icon = getIcon(icon);
  return (
    <Box>
      <Box
        display="grid"
        gridTemplateColumns="56px 1fr"
        gridColumnGap={[20, null, "3.57vw", null]}
      >
        <Box display="flex" flexDirection="column" alignItems="center">
          <Icon aria-label={`Step ${number}`} />
        </Box>
        <BodyTextMedium>
          {`<strong>${number}</strong> - ${text}`}
        </BodyTextMedium>
      </Box>
      {showArrow && (
        <Box
          mt={[22, null, 24, null]}
          width={["100%", null, 56, null]}
          display="flex"
          justifyContent="center"
        >
          <GreenArrow />
        </Box>
      )}
    </Box>
  );
}

export default TakebackStep;
